import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { FormInputComponent } from '../../../components/ui-components/forms/form-input/form-input.component';
import { CardButtonComponent } from '../../../components/ui-components/buttons/card-button/card-button.component';
import { CardButtonBackground, CardButtonSize } from '../../../components/ui-components/buttons/card-button/card-button.model';
import { FormInputType } from '../../../components/ui-components/forms/form-input/form-input.model';
import { TenderType } from 'src/app/services/model/tender-type.enum';
import { ReportExportService } from 'src/app/services/report-export.service';
import { StateService } from 'src/app/services/state.service';
import { DropdownComponent } from '../../../components/ui-components/dropdown/dropdown.component';
import { DropdownOption } from 'src/app/components/ui-components/dropdown/dropdown.model';
import { SafeUrlPipe } from "../../../pipes/safe-url.pipe";
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { ReportType } from 'src/app/services/model/reportType.model';
import { ReportUrlService } from 'src/app/services/report-url.service';

@Component({
  selector: 'app-report-container',
  templateUrl: './report-container.component.html',
  styleUrls: ['./report-container.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    SafeUrlPipe,
],
})
export class ReportContainerComponent implements OnInit, OnDestroy {

  reportUrl: string | null = null;
  private stateService = inject(StateService);
  private reportUrlService = inject(ReportUrlService);
  private paramSubscription: Subscription | undefined;

  constructor(
    private reportExportService: ReportExportService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.paramSubscription = this.activatedRoute.params.subscribe(async params => {
      const reportName = params['name'];
      if (reportName && environment.reporting.paths[reportName as keyof typeof environment.reporting.paths]) {
        const reportPath = environment.reporting.paths[reportName as keyof typeof environment.reporting.paths];
        var reportUrlTemp = environment.reporting.baseUrl + reportPath;
        // replace any parameters in the URL template
        // convert report name to ReportType enum
        const reportType = reportName as ReportType;
        this.reportUrl = await this.reportUrlService.getReportUrl(reportType);
        this.stateService.pageNameOverride.set(reportName);
      } else {
        console.warn(`Report '${reportName}' not found in environment configuration`);
        this.reportUrl = null;
      }
    });
  }

  ngOnDestroy(): void {
    this.paramSubscription?.unsubscribe();
  }

  downloadReportPdf(): void {
    const iframe = document.getElementsByName('report-iframe')[0] as HTMLIFrameElement | undefined;
    if (!this.reportExportService.requestExportFromIframe(iframe, { showProcessingDialog: true })) {
      console.warn('Report iframe is not ready for export');
    }
  }
}